import { getTextToSpeech } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { useCallback } from 'react';
export const useTextToSpeech = _ref => {
  let {
    httpClient
  } = _ref;
  const getSpeechFromText = useCallback(async text => {
    if (!httpClient) {
      throw new Error('httpClient is not defined');
    }

    // Limit the text to 4096 characters as per the API constraints
    const maxAllowedContent = text.substring(0, 4096);
    try {
      const {
        data
      } = await httpClient.request(getTextToSpeech({
        text: maxAllowedContent
      }));
      return data.audioData || new Uint8Array();
    } catch (error) {
      throw new Error(`Text to speech failed: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }, [httpClient]);
  return {
    getSpeechFromText
  };
};
//# sourceMappingURL=useTextToSpeech.js.map